import { Config } from "common/config";
import { EColors } from "common/styles";
import { SpanColor } from "components/SpanColor";
import { Styled } from "components/Styled";
import { Fade } from "react-awesome-reveal";
import { Component } from "./components";
import { StyledQualityWrapper, StyledTitle, StyledTitleMob } from "./styles";

export const Certificates = () => {
  return (
    <Styled.Section id={Config.Section.certificates} color={EColors.white}>
      <StyledQualityWrapper>
        <Styled.Half>
          <StyledTitle>
            <SpanColor bgColor={EColors.accent_300}>Якість,</SpanColor> що
            гарантується
          </StyledTitle>
          <Component.ListСertificates />
        </Styled.Half>
        <Styled.Half>
          <StyledTitleMob>
            <SpanColor bgColor={EColors.accent_300}>Якість,</SpanColor> що
            гарантується
          </StyledTitleMob>
          <Styled.PBody1>
            Ваша безпека та спокій – наші пріоритети. Ми гордо оголошуємо, що
            наше пальне проходить строгий контроль якості та має сертифікати, що
            підтверджують його відповідність найвищим стандартам.
            <br />
            <br />
            Наші сертифікати про якість пального гарантують, що кожна крапля,
            яку ви заправляєте, є чистою, надійною та відповідає усім нормам
            безпеки. Ми використовуємо передові технології та процеси
            виробництва, щоб забезпечити вам найкращу якість пального.
            <br />
            <br />
            Ви можете заправлятися на нашій автозаправній станції з впевненістю,
            знаючи, що кожна крапля пального, яку ви отримуєте, має гарантовану
            якість. Наші сертифікати про якість – це ваша гарантія пального, на
            яке ви можете покладатися.
            <br />
            <br />
            Зверніться до нас, якщо в у вас виникли будь-які питання щодо
            сертифікатів або якості нашого пального. Ми завжди готові надати вам
            додаткову інформацію та забезпечити вас надійним та якісним паливом.
          </Styled.PBody1>
        </Styled.Half>
      </StyledQualityWrapper>
    </Styled.Section>
  );
};
